import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    viaticosRubros: [],
    /* Info de paginación */
    paginaActual: 1,
    totalPaginas: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,

    nombreBusqueda: '',
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.viaticosRubros = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombreBusqueda = '';
    },

    'INICIALIZAR' (state) {
        state.viaticosRubros = [];
    },
    'SET_VIATICOS_RUBROS' (state, viaticosRubros) {
        state.viaticosRubros = viaticosRubros;
    },
    'SET_FILTERED_PAGINATION' (state, params) {
        state.paginaActual = params.paginaActual;
        state.totalRegistros = params.totalRegistros;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getViaticosRubros: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit ('INICIALIZAR');

            apiAxios.get('viaticos-rubros')
            .then(res => {
                let params = {
                    paginaActual: 1,
                    totalRegistros: res.data.length
                }
                commit ('SET_FILTERED_PAGINATION', params);
            
                commit ('SET_VIATICOS_RUBROS', res.data);
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
};

const getters = {
    getField,
    
    viaticosRubros (state) {
        return state.viaticosRubros;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}